import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormDirectivesService {
  /**
   * Format international phone number for display
   * Accepts E.164 format (e.g., +27721231234, +14155551234)
   * Returns formatted string with country code (e.g., "+27 72 123 1234", "+1 415 555 1234")
   * For display use only - input fields should use ngx-intl-tel-input
   */
  formatInternationalPhone(value: string): string {
    if (!value) {
      return value;
    }

    // Ensure it starts with +
    let e164 = value.trim();
    if (!e164.startsWith('+')) {
      e164 = '+' + e164;
    }

    // Extract just the digits
    const digits = e164.replaceAll(/\D/g, '');

    // Common country code patterns
    if (digits.startsWith('27') && digits.length === 11) {
      // South Africa: +27 XX XXX XXXX
      return digits.replace(/^(\d{2})(\d{2})(\d{3})(\d{4})$/, '+$1 $2 $3 $4');
    } else if (digits.startsWith('1') && digits.length === 11) {
      // USA/Canada: +1 XXX XXX XXXX
      return digits.replace(/^(\d)(\d{3})(\d{3})(\d{4})$/, '+$1 $2 $3 $4');
    } else if (digits.startsWith('44') && digits.length >= 11) {
      // UK: +44 XXXX XXXXXX
      return digits.replace(/^(\d{2})(\d{4})(\d+)$/, '+$1 $2 $3');
    } else if (digits.startsWith('61') && digits.length >= 11) {
      // Australia: +61 XXX XXX XXX
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d+)$/, '+$1 $2 $3 $4');
    } else if (digits.length > 10) {
      // Generic fallback for longer numbers: Assume 2-digit country code
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d+)$/, '+$1 $2 $3 $4');
    } else {
      // Generic fallback for shorter numbers: Add + and space every 3-4 digits
      return '+' + digits.replace(/(\d{2,3})(\d{3})(\d+)/, '$1 $2 $3');
    }
  }

  idNumberMask(value: string) {
    if (value) {
      let newValue = value.replace(/[^a-z0-9]/g, '').replace(' ', '');
      if (newValue.length > 6) {
        newValue = newValue.replace(/(\d{6})(\d{4})(\d{2})(\d)/, '$1 $2 $3 $4');
      } else if (newValue.length > 4) {
        newValue = newValue.replace(/(\d{4})(\d{2})(\d)/, '$1 $2 $3');
      } else if (newValue.length > 2) {
        newValue = newValue.replace(/(\d{2})(\d)/, '$1 $2');
      }
      return newValue;
    }
    return value;
  }
}
